export default __webpack_public_path__ + "static/screenSixthSectionUk-35c899e0bca6dda03ab01b0ece6d100a.webp";